export const ENV_VN = {
    mode: 'Staging'
    , production: false
    , msalConfig: {
         auth: {
            clientId: 'NO_SETTING'
            , authority: 'NO_SETTING'
            , tenantId: 'NO_SETTING'
        }
    }
    , apiConfig: {
        scopes: ['NO_SETTING']
        , uri: 'NO_SETTING'
        , postLogoutRedirectUri: 'NO_SETTING'
        , redirectUri: 'NO_SETTING'
    }
    , unauthorizedConfig: {
        unauthorizedUrl: 'NO_SETTING'
        , unauthorizedRedirect: 'NO_SETTING'
    }
    , redirectConfig: {
        connectPlusUrl: 'NO_SETTING'
        , connectClientUrl: 'NO_SETTING'
    }
  }


// WEBPACK FOOTER //
// ./src/environment/environment.vn.ts